import { blacklistTypes } from './blacklist.types';

export const fetchBlacklistStart = () => ({
  type: blacklistTypes.FETCH_BLACKLIST_START,
});

export const setBlacklist = (blacklist) => ({
  type: blacklistTypes.SET_BLACKLIST,
  payload: blacklist,
});

export const loadingBlacklist = () => ({
  type: blacklistTypes.LOADING_BLACKLIST,
});

export const removeUserFromBlacklistStart = (blockedUser) => ({
  type: blacklistTypes.REMOVE_USER_FROM_BLACKLIST_START,
  payload: blockedUser,
});
